module.exports = __webpack_public_path__ + "img/placeholderhepn.b027d256.jpg";